var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12.5342 19.2433L13.2765 18.4114C14.1872 17.3907 15.8213 17.5234 16.5554 18.6777C17.2393 19.753 18.7251 19.9568 19.6733 19.1054L21.0188 17.8974M2.97656 19.4704L7.34255 18.5907C7.57432 18.544 7.78714 18.4298 7.95428 18.2626L17.728 8.48356C18.1966 8.01471 18.1962 7.25472 17.7272 6.78626L15.6568 4.71818C15.188 4.24991 14.4284 4.25023 13.96 4.71889L4.18533 14.4989C4.01851 14.6658 3.90461 14.8782 3.85787 15.1095L2.97656 19.4704Z",
    stroke: "#657397",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.ac152e69a1c213dd0682092e4bdd1332.svg";
export { ForwardRef as ReactComponent };